import React, { FC } from 'react';
import classNames from 'classnames';

import Spinner from 'vibo-ui/Spinner';
import Brick from 'components/Placeholders/Brick';

import { MODAL_PLACEHOLDERS } from './constans';

import { ModalView } from 'vibo-ui/Modal';
import { ModalPlaceholderProps } from './interfaces';

import useStyles from './style';

const ModalPlaceholder: FC<ModalPlaceholderProps> = ({ name }) => {
  const classes = useStyles();

  const info = MODAL_PLACEHOLDERS[name];
  const view = info?.view ?? ('default' as ModalView);

  return (
    <div className={classes.modalPlaceholderOverlay}>
      <div
        className={classNames(classes.modalPlaceholder, info?.size ?? 'sm', view, classes[view])}
      >
        <div className="header" />
        <div className="body">
          <Spinner />
        </div>
        {info?.withFooter ? (
          <div className="footer">
            <Brick />
            <Brick />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ModalPlaceholder;
